import { Base, PageObject } from '@testsigmainc/models';
import { deserialize, list, object, serializable } from 'serializr';
import { DrifterSupportedArchitecture } from '../enums/drifter-supported-archs.enum.js';

class File {
  @serializable
  type: string;
  @serializable
  url: string;
  @serializable
  sha512: string;
  @serializable
  size: number;
}

class ArtifactConfig {
  @serializable(list(object(File)))
  files: File[];
}

class Artifacts {
  @serializable(object(ArtifactConfig))
  [DrifterSupportedArchitecture.DARWIN_ARCH_64]: ArtifactConfig;
  @serializable(object(ArtifactConfig))
  [DrifterSupportedArchitecture.DARWIN_X86_64]: ArtifactConfig;
  @serializable(object(ArtifactConfig))
  [DrifterSupportedArchitecture.Linux]: ArtifactConfig;
  @serializable(object(ArtifactConfig))
  [DrifterSupportedArchitecture.Windows]: ArtifactConfig;
}

class DrifterVersionConfig extends Base implements PageObject {
  @serializable
  version: string;
  @serializable
  releaseDate: string;
  @serializable(object(Artifacts))
  artifacts: Artifacts;

  deserialize(input: any): this {
    const deserializedData = Object.assign(
      this,
      deserialize(DrifterVersionConfig, input),
    );
    for (const platformKey in deserializedData.artifacts) {
      if (deserializedData.artifacts.hasOwnProperty(platformKey)) {
        const platform = deserializedData.artifacts[platformKey];

        if (Array.isArray(platform?.files)) {
          platform.files = platform.files.reduce<Record<string, File>>(
            (acc, asset) => {
              acc[asset.type] = asset;
              return acc;
            },
            {},
          );
        }
      }
    }
    return deserializedData;
  }
}

export { DrifterVersionConfig };
